const $ = require('jquery').default
const ctor = require('tpm-lib/widgets/controller').default
const fuze = require('tpm-utils').fuze

const controller = new ctor()

module.exports = (requireCtx => {
  const exportObj = {}

  requireCtx.keys().forEach(modId => {
    const mod = requireCtx(modId)
    for (let modExport in mod) {
      exportObj[modExport] = mod[modExport]
    }

    if (module.hot) {
      module.hot.accept(modId, () => {
        controller.init(exportObj)
      })
    }
  })

  $(() => controller.init(exportObj))

  return exportObj
})(require.context('./widgets', false, /\.js$/))
